import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreLinkComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-link/mapfre-link.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { Router , RouterModule } from '@angular/router';
import { AddPolicyDataService } from './../../../../_services/signup-process-service/add-policy-data.service';
import { UserService } from '../../../../_services/user.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreLinkComponent, MapfreButtonComponent],
  selector: 'app-not-found-commercial',
  templateUrl: './not-found-commercial.component.html',
})
export class NotFoundCommercialComponent implements OnInit {
  userData: any;
  amountOfTries: number;
  policyHolderName: string;
  policyNumber: string;
  noOfAttempts = 0;

  constructor(
    private addPolicyDataService: AddPolicyDataService,
    private router: Router,
    private userService: UserService
  ) {}

  getObservableData(userData): void {
    this.policyHolderName = `${userData.userDetails.firstName} ${userData.userDetails.middleName} ${userData.userDetails.lastName}`;
    this.policyNumber = `${userData.policyDetail.policynumber.policyNumber}`;
  }

  goBackAPage(): void {
    this.router.navigate(['signup']);
  }

  updateObservable(userData): void {
    userData.addPolicyAttempts = userData.addPolicyAttempts + 1;
    this.userData = userData;
    this.noOfAttempts = this.userData.addPolicyAttempts;
  }

  ngOnInit() {
    this.userService.$user.subscribe((user) => {
      if (!user.addPolicyAttempts) {
        user.addPolicyAttempts = 0;
      }
      this.updateObservable(user);
    });
    this.addPolicyDataService.$newPolicy.subscribe((userData) => {
      this.userData = userData;
    });
    this.getObservableData(this.userData);
  }
}
